module.exports = __webpack_public_path__ + "assets/img/liucheng.88513f2c.png";